import { useParams } from 'react-router-dom';

import { CohortAttritionTable } from '@verantos-dev/feature-cohort-attrition';
import { CohortCharacteristics } from '@verantos-dev/feature-cohort-characteristics';
import { CohortSubjectsList } from '@verantos-dev/feature-subjects-list';

import { PageTabContent } from '../../cohort-builder-page-layout/StyledPageTabContent/PageTabContent';

// TODO: add test cases for all the internal components, hooks, and helpers
export const ResultsPageTabContent = ({
  isFinalFetchTimerActive,
}: {
  isFinalFetchTimerActive: boolean;
}) => {
  const { projectId, cohortId } = useParams();

  return (
    <PageTabContent>
      {projectId && cohortId && (
        <>
          <CohortAttritionTable projectId={projectId} cohortId={cohortId} />
          <CohortCharacteristics
            projectId={projectId}
            cohortId={cohortId}
            isFinalFetchTimerActive={isFinalFetchTimerActive}
          />
          <CohortSubjectsList projectId={projectId} cohortId={cohortId} />
        </>
      )}
    </PageTabContent>
  );
};
